module.exports = __webpack_public_path__ + "static/pic08-b86cad178e94d50f927662302e065f69.jpg";